import { formatDateX } from './formatDateX';

const TimeFormat = 'HH:mm';

export function formatTime(date: Date | undefined | null | string | number): string {
	return formatDateX(date, TimeFormat);
}
